// ─────────────────────────────────────────────────────────────────────────────
// IS THE CUSTOMER'S EMAIL CONNECTED? One answer, because there were two wrong ones.
//
// Found 2026-10-04 while clearing the read-never-written keys. `currentUser.
// emailConnections` is an ARRAY of rows — lib/users.js selects
// `{ id, provider, email, connectedAt }` per connection — and two places read it as
// though it were an object keyed by provider:
//
//   Settings/NotificationSettings.jsx  read localStorage['emailConnections'], a key
//                                      NOTHING WRITES, so emailLinked was always
//                                      false and the email-notification options were
//                                      hidden from people whose email IS connected
//   Briefing/MorningBriefing.jsx       read currentUser.emailConnections.gmail
//                                      .connected — undefined on an array, so also
//                                      always false
//
// Settings/CalendarSettings.jsx had it right all along (`.filter(c => c.provider ===
// 'gmail')`), which is how the correct shape was confirmed.
//
// Two readers, two different wrong answers, and both failed in the SAFE-LOOKING
// direction: they hid a feature rather than offering a broken one, which is exactly
// why nobody noticed.
// ─────────────────────────────────────────────────────────────────────────────

const PROVIDERS = ['gmail', 'outlook', 'imap'];

/** Every connected provider, lower-cased. [] when there are none or the shape is odd. */
export function connectedEmailProviders(currentUser) {
  const list = currentUser?.emailConnections;
  if (!Array.isArray(list)) return [];
  return list
    .map(c => String(c?.provider || '').toLowerCase())
    .filter(p => PROVIDERS.includes(p));
}

/** True when at least one email account is connected. */
export function isEmailConnected(currentUser) {
  return connectedEmailProviders(currentUser).length > 0;
}

/** True for one named provider. */
export function hasEmailProvider(currentUser, provider) {
  return connectedEmailProviders(currentUser).includes(String(provider).toLowerCase());
}
